import React from 'react';
import { css } from 'emotion';

const drawerStyle = css`
  display: block;
  position: relative;
  height: 100%;
`;

const DrawerPage = ({ children }) => (
  <div className={drawerStyle}>{children}</div>
);

export default DrawerPage;
